module.exports = __webpack_public_path__ + "static/media/img-background3.744d6849.jpg";